import { render, staticRenderFns } from "./DesktopNew.vue?vue&type=template&id=a698a502&"
import script from "./DesktopNew.vue?vue&type=script&lang=js&"
export * from "./DesktopNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports